import axios from "axios";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { createBrowserHistory } from "history";
import { handleRequests } from "@redux-requests/core";
import { createDriver } from "@redux-requests/axios";
import { onError, onSuccess } from "./interceptors";
import {
  AppEntity,
  AuthEntity,
  ProfileEntity
} from "./entities";
import {composeWithDevTools} from "redux-devtools-extension";
import settings from "../config/settings"

const axiosInstance = axios.create({
  baseURL: `${settings.REACT_APP_ENDPOINT}/api`,
});

const configureStore = () => {
  const { requestsReducer, requestsMiddleware } = handleRequests({
    driver: createDriver(axiosInstance),
    onSuccess,
    onError,
  });

const reducers = combineReducers({
    requests: requestsReducer,
    app: AppEntity.reducer,
    auth: AuthEntity.reducer,
    profile: ProfileEntity.reducer,
  });

  return createStore(
    reducers,
    composeWithDevTools(applyMiddleware(...requestsMiddleware)),
  );
};

export const history = createBrowserHistory();
export const store = configureStore();
